<template>
  <div class="text-left">
    <div class="row">
      <div class="col col-sm-6">
        <h3 class="font-weight-bolder mt-2">Crew Education</h3>
      </div>
      <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
        <template v-if="crew.active == 1 || isSystemAdmin">
          <div class="col col-sm-6 my-auto">
            <button class="btn btn-sm btn-xs btn-outline-primary text-small font-weight-bold float-right"
                    data-toggle="modal" data-target="#newCrewEducation"
            >
              <span class="fas fa-plus"></span>
              Add Education
            </button>
          </div>
        </template>
      </template>


      <div class="col col-sm-12">
        <table class="table table-hover table-bordered table-template-1 text-small">
          <thead>
          <tr>
            <th>#</th>
            <th>Level</th>
            <th>Course</th>
            <th>School Name</th>
            <th>School Address</th>
            <th>Date Graduated</th>
            <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
              <template v-if="crew.active == 1 || isSystemAdmin">
                <th>Action</th>
              </template>
            </template>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(crewEducation, index) in crew.crew_educations" :key="crewEducation.id">
            <td>{{ index + 1 }}</td>
            <td>{{ crewEducation.education_level.name }}</td>
            <td>{{ crewEducation.course }}</td>
            <td>{{ crewEducation.school }}</td>
            <td>{{ crewEducation.address }}</td>
            <td class="text-center">{{ crewEducation.date_graduated | moment('DD MMM Y') }}</td>
            <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
              <template v-if="crew.active == 1 || isSystemAdmin">
                <td class="text-center">
                  <button class="btn btn-sm btn-xs btn-warning"
                          data-toggle="modal"
                          data-target="#editCrewEducation"
                          @click="updateEditCrewEducation(crewEducation)"
                  >
                    <span class="fas fa-edit"></span>
                  </button>
                  <button class="btn btn-sm btn-xs"
                          title="Remove this Crew Education"
                          @click="confirmDeleteCrewEducation(crewEducation.id)"
                  >
                    <span class="fas fa-minus text-danger"></span>
                  </button>
                </td>
              </template>
            </template>

          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="modal fade" id="newCrewEducation" tabindex="-1" role="dialog" aria-labelledby="newCrewEducationTitle"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form class="modal-content" @submit.prevent="confirmAddNewCrewEducation">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="newCrewLanguageTitle">
              New Crew Education
            </h5>
            <button type="button" id="closeNewCrewEducation" class="close"
                    data-dismiss="modal" aria-label="Close" @click="refreshNewCrewEducation"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-small">
            <p class="pl-4"> <span class="font-weight-bold text-danger">*</span> Required fields </p>
            <div class="form-group form-row mb-1" :class="{'has-error': newCrewEducationError.education_level_id}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationLevel">
                Level: <span class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <select id="newCrewEducationLevel"
                        class="form-control form-control-xs"
                        v-model="newCrewEducation.education_level_id"
                        @change="toggleCourse(newCrewEducation.education_level_id)"
                >
                  <option :value="null">--- SELECT LEVEL ---</option>
                  <option v-for="educationLevelKey in educationLevelKeys" :key="educationLevelKey.id"
                          :value="educationLevelKey.id">
                    {{ educationLevelKey.name }}
                  </option>
                </select>
                <span class="help-block" v-if="newCrewEducationError.education_level_id !== ''">
                                    <small><strong>{{ newCrewEducationError.education_level_id }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewEducationError.school}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationSchool">
                School: <span class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <input type="text" id="newCrewEducationSchool"
                       class="form-control form-control-xs"
                       placeholder="Enter School Here"
                       v-model="newCrewEducation.school"
                >
                <span class="help-block" v-if="newCrewEducationError.school !== ''">
                                    <small><strong>{{ newCrewEducationError.school }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewEducationError.course}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationCourse">
                Course: <span v-show="[3,4].includes(newCrewEducation.education_level_id)" class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <input type="text" id="newCrewEducationCourse" :disabled="![3,4].includes(newCrewEducation.education_level_id)"
                       class="form-control form-control-xs"
                       placeholder="Enter Course Here"
                       v-model="newCrewEducation.course"
                >
                <span class="help-block" v-if="newCrewEducationError.course !== ''">
                                    <small><strong>{{ newCrewEducationError.course }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewEducationError.address}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationAddress">
                Address:
              </label>

              <div class="col col-sm-10">
                                <textarea id="newCrewEducationAddress"
                                          class="form-control form-control-xs"
                                          placeholder="Enter Address Here"
                                          v-model="newCrewEducation.address"
                                ></textarea>
                <span class="help-block" v-if="newCrewEducationError.address !== ''">
                                    <small><strong>{{ newCrewEducationError.address }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewEducationError.date_graduated}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-left" for="newCrewEducationGraduated">
                Date Graduated: <span class="text-danger">*</span>
              </label>
<!--              min="1900-01-01"-->
<!--              :max="dateToday"-->
              <div class="col col-sm-10">
                <input type="date" id="newCrewEducationGraduated" class="form-control form-control-xs"
                       placeholder="Enter School Here"
                       v-model="newCrewEducation.date_graduated"
                >
                <span class="help-block" v-if="newCrewEducationError.date_graduated !== ''">
                                    <small><strong>{{ newCrewEducationError.date_graduated }}</strong></small>
                                </span>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
              <span class="fas fa-plus"></span>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" id="editCrewEducation" tabindex="-1" role="dialog" aria-labelledby="editCrewEducationTitle"
         aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="confirmUpdateCrewEducation">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="editCrewEducationTitle">
              Edit Crew Education
            </h5>
            <button type="button" id="closeEditCrewEducation" class="close"
                    data-dismiss="modal" aria-label="Close" @click="refreshEditCrewEducation"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-small">
            <p class="pl-4"> <span class="font-weight-bold text-danger">*</span> Required fields </p>
            <div class="form-group form-row mb-1" :class="{'has-error': editCrewEducationError.education_level_id}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationLevel">
                Level: <span class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <select id="newCrewEducationLevel"
                        class="form-control form-control-xs"
                        v-model="editCrewEducation.education_level_id"
                        @change="toggleCourse(editCrewEducation.education_level_id,2)"
                >
                  <option :value="null">--- SELECT LEVEL ---</option>
                  <option v-for="educationLevelKey in educationLevelKeys" :key="educationLevelKey.id"
                          :value="educationLevelKey.id">
                    {{ educationLevelKey.name }}
                  </option>
                </select>
                <span class="help-block" v-if="editCrewEducationError.education_level_id !== ''">
                                    <small><strong>{{ editCrewEducationError.education_level_id }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewEducationError.school}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationSchool">
                School: <span class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <input type="text" id="newCrewEducationSchool"
                       class="form-control form-control-xs"
                       placeholder="Enter School Here"
                       v-model="editCrewEducation.school"
                >
                <span class="help-block" v-if="editCrewEducationError.school !== ''">
                                    <small><strong>{{ editCrewEducationError.school }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewEducationError.course}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationCourse">
                Course: <span v-show="[3,4].includes(editCrewEducation.education_level_id)" class="text-danger">*</span>
              </label>

              <div class="col col-sm-10">
                <input type="text" id="newCrewEducationCourse" :disabled="![3,4].includes(editCrewEducation.education_level_id)"
                       class="form-control form-control-xs"
                       placeholder="Enter Course Here"
                       v-model="editCrewEducation.course"
                >
                <span class="help-block" v-if="editCrewEducationError.course !== ''">
                                    <small><strong>{{ editCrewEducationError.course }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewEducationError.address}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="newCrewEducationAddress">
                Address:
              </label>

              <div class="col col-sm-10">
                                <textarea id="newCrewEducationAddress"
                                          class="form-control form-control-xs"
                                          placeholder="Enter Address Here"
                                          v-model="editCrewEducation.address"
                                ></textarea>
                <span class="help-block" v-if="editCrewEducationError.address !== ''">
                                    <small><strong>{{ editCrewEducationError.address }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewEducationError.date_graduated}">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-left" for="newCrewEducationGraduated">
                Date Graduated: <span class="text-danger">*</span>
              </label>
              <!--              min="1900-01-01"-->
              <!--              :max="dateToday"-->
              <div class="col col-sm-10">
                <input type="date" id="newCrewEducationGraduated" class="form-control form-control-xs"
                       placeholder="Enter School Here"
                       v-model="editCrewEducation.date_graduated"
                >
                <span class="help-block" v-if="editCrewEducationError.date_graduated !== ''">
                                    <small><strong>{{ editCrewEducationError.date_graduated }}</strong></small>
                                </span>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-warning font-weight-bolder">
              <span class="fas fa-edit"></span>
              Update
            </button>
          </div>
        </form>
      </div>
    </div>


  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "../../../../../../mixins/vueAppMixin";
import {formMixin} from "../../../../../../mixins/formMixin";
import {gateMixin} from "@/mixins/gateMixin";

export default {
  name: "CrewEducation",
  mixins: [vueAppMixin, formMixin, gateMixin],

  data() {
    return {
      newCrewEducation: {},
      newCrewEducationError: [],
      editCrewEducation: {},
      editCrewEducationError: [],
      tempCrewCourse:'',
      dateToday:(new Date()).toISOString().substring(0,10),
    }
  },

  methods: {
    ...mapActions(['getEducationLevelKeys', 'addCrewEducation', 'updateCrewEducation', 'deleteCrewEducation']),

    async confirmAddNewCrewEducation() {
      if (await this.confirmCreateAlert()) {
        var confirmation=await this.additionalCrewEducation(this.newCrewEducation);
        if(typeof confirmation === 'boolean' && confirmation===true){
          let newCrewEducation = await this.addCrewEducation(this.newCrewEducation);
          if (newCrewEducation) {
            if (newCrewEducation.errors) {
              this.newCrewEducationError = newCrewEducation.errors;
            } else {
              this.successAlert('Crew Education Successfully Created', 'CREATE');
              this.refreshNewCrewEducation();
              document.getElementById('closeNewCrewEducation').click();
            }
          }
        }
        if(confirmation===undefined){
          let newCrewEducation = await this.addCrewEducation(this.newCrewEducation);
          if (newCrewEducation) {
            if (newCrewEducation.errors) {
              this.newCrewEducationError = newCrewEducation.errors;
            } else {
              this.successAlert('Crew Education Successfully Created', 'CREATE');
              this.refreshNewCrewEducation();
              document.getElementById('closeNewCrewEducation').click();
            }
          }
        }

      }
    },

    async confirmUpdateCrewEducation() {
      if (await this.confirmUpdate()) {
        let params = {
          crewEducationId: this.editCrewEducation.id,
          education_level_id: this.editCrewEducation.education_level_id,
          course: this.editCrewEducation.course,
          school: this.editCrewEducation.school,
          address: this.editCrewEducation.address,
          date_graduated: this.editCrewEducation.date_graduated,
          crew_id:this.editCrewEducation.crew_id
        };
        var confirmation=await this.additionalCrewEducation(params,false);
        if(typeof confirmation === 'boolean' && confirmation===true){
          let updatedCrewEducation = await this.updateCrewEducation(params);
          if (updatedCrewEducation) {
            if (updatedCrewEducation.errors) {
              this.editCrewEducationError = updatedCrewEducation.errors;
            } else {
              this.successAlert('Crew Education Successfully Updated', 'UPDATE');
              document.getElementById('closeEditCrewEducation').click();
              this.refreshEditCrewEducation();
            }
          }
        }
        if(typeof confirmation==='undefined'){
          let updatedCrewEducation = await this.updateCrewEducation(params);
          if (updatedCrewEducation) {
            if (updatedCrewEducation.errors) {
              this.editCrewEducationError = updatedCrewEducation.errors;
            } else {
              this.successAlert('Crew Education Successfully Updated', 'UPDATE');
              document.getElementById('closeEditCrewEducation').click();
              this.refreshEditCrewEducation();
            }
          }
        }
      }
    },

    async confirmDeleteCrewEducation(crewEducationId) {
      if (await this.confirmDeleteAlert()) {
        if (await this.deleteCrewEducation(crewEducationId)) {
          this.successAlert('Crew Education Successfully Deleted', 'DELETE');
        }
      }
    },

    refreshNewCrewEducation() {
      this.newCrewEducation = {crew_id: this.crew.id, education_level_id: null, active: true};
      this.newCrewEducationError = [];
      this.tempCrewCourse='';
    },

    refreshEditCrewEducation() {
      this.editCrewEducation = {};
      this.editCrewEducationError = [];
      this.tempCrewCourse='';
    },

    updateEditCrewEducation(crewEducation) {
      this.refreshEditCrewEducation();
      this.editCrewEducation = Object.assign({}, crewEducation);
      this.tempCrewCourse=this.editCrewEducation.course;
    },
   async additionalCrewEducation(crewEducation,insert=true){
      let crewEducationLists=this.crew.crew_educations;
      let crewEducationCount=0;
      if(insert){
         crewEducationCount=crewEducationLists.filter(educ=> educ.education_level_id===crewEducation.education_level_id).length
      }
      else {
         crewEducationCount=crewEducationLists.filter(educ=>{return (educ.education_level_id===crewEducation.education_level_id)}).length - 1
      }

      let educationalLevel=this.educationLevelKeys.filter(level=>level.id===crewEducation.education_level_id);
      if(crewEducationCount >= 1){
        return await swal.fire({
          'title': `ADD ADDITIONAL ${educationalLevel[0].name}`,
          'html': `<p>ARE YOU SURE YOU WANT TO ADD ANOTHER ${educationalLevel[0].name} LEVEL TO THE LIST ? </p>`,
          showCancelButton: `true`,
        }).then(result => {
          return !!result.value;
        });
      }
      return undefined;
    },
    toggleCourse(courseId,crudOp=1){
      if(crudOp !== 1){
        if(![3,4].includes(this.editCrewEducation.education_level_id)){
          if(!this.tempCrewCourse){
            this.tempCrewCourse=this.editCrewEducation.course;
          }
          this.editCrewEducation.course='';
        }
        else {
          this.editCrewEducation.course=this.tempCrewCourse;
        }
      }
      else{
        if(![3,4].includes(this.newCrewEducation.education_level_id)){
          if(!this.tempCrewCourse){
            this.tempCrewCourse=this.newCrewEducation.course;
          }
          this.newCrewEducation.course='';
        }
        else {
          this.newCrewEducation.course=this.tempCrewCourse;
        }
      }

    }
  },

  computed: {
    ...mapGetters(['crew', 'educationLevelKeys'])
  },

  created() {
    this.refreshNewCrewEducation();
    this.getEducationLevelKeys();
  }

}
</script>

<style scoped>

</style>
